
<mat-form-field class="demo-full-width margin-top" [formGroup]="group">
<mat-select [placeholder]="field.label" [formControlName]="field.name" [(value)]="field.value">
<mat-option *ngFor="let item of field.options" [value]="item['value']">{{item['name']}}</mat-option>
</mat-select>
</mat-form-field>
